import { FC, useContext } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Button, Icon } from '@chakra-ui/react';

import { DocumentListContext } from '../application';

export const ClearFiltersButton: FC = () => {
  const { setStateFilters } = useContext(DocumentListContext);

  const clearFilters = (): void => {
    setStateFilters({});
  };

  return (
    <Button colorPalette="red" onClick={clearFilters} size="sm" variant="solid">
      Clear filters
      <Icon as={AiOutlineClose} />
    </Button>
  );
};
